export default __webpack_public_path__ + "static/media/c.22ea43c1.svg";